import React, { useEffect, useState } from 'react'
import { Product } from '../../types/types'
import ProductCard from '../ProductCard/ProductCard'

import './PaginatedList.scss'

interface PaginationSettings {
    products: Product[],
    pageSize: number
}

const PaginatedList = (props: PaginationSettings) => {
    let [currentPage, setCurrentPage] = useState(0)
    const totalPages = Math.ceil(props.products.length / props.pageSize)
    const [itemsToDisplay, setItemsToDisplay] = useState<Product[]>(props.products.slice(currentPage * props.pageSize, props.pageSize * (currentPage + 1)))

    useEffect(()=>{
        setItemsToDisplay(props.products.slice(currentPage * props.pageSize, props.pageSize * (currentPage + 1)))
        if(currentPage > totalPages) setCurrentPage(0)
    }, [currentPage, setItemsToDisplay, props.products, props.pageSize, totalPages])
  return (
    <div>
        <div className="paginated-list">
                {itemsToDisplay.length > 0 ? 
                    itemsToDisplay.map((item) => {
                        return (<ProductCard key={item.id} product={item}/>)
                    }) : (<div className='placeholder-text'>
                        <span>No results were founded!</span>
                    </div> ) 
            }
        </div>
        <div className="pagination">
            {[...Array(totalPages)].map((item, index) => {
                return (<span key={index} className={'pagination-item ' + (currentPage===index ? 'active' : '')} onClick={() => {setCurrentPage(index)}}>{index+1}</span>)
            })}
        </div>
    </div>
  )
}

export default PaginatedList